module.exports = __webpack_public_path__ + "static/fonts/proximasoft-webfont.0db40ab.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoft-webfont.eot
// module id = 1015
// module chunks = 11